import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-5dca0f8a"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "video-component"
};
const _hoisted_2 = {
  id: "mse",
  ref: "videoRef",
  class: "video-player"
};
import ShakaJsPlayer from 'xgplayer-shaka';
import HlsJsPlayer from 'xgplayer-hls.js';
import { ref } from 'vue';
import { ElMessage } from 'element-plus';
import { useI18n } from 'vue-i18n';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: ['url'],
  emits: ['change'],

  setup(__props, {
    expose,
    emit
  }) {
    const props = __props;
    const {
      t
    } = useI18n();
    const video = ref({
      /** 播放器实例 */
      player: null,
      src: ''
    }); //父组件传过来的url
    // =========================1，区分播放器类别，销毁之前的播放器===================

    const initPlayer = () => {
      const videoType = /.*(\.m3u8)$/.test(props.url) ? 'HlsJsPlayer' : 'ShakaJsPlayer';

      if (video.value.player) {
        video.value.player.src = '';
        video.value.player.destroy(true);
        emit('change', 'destroy');
      } //========================== 2，开始实例化,组件仅支持dash、hls格式的视频======================


      switch (videoType) {
        case 'ShakaJsPlayer':
          video.value.player = new ShakaJsPlayer({
            id: 'mse',
            url: props.url,
            width: 550,
            height: 351,
            lang: 'en',
            fitVideoSize: 'auto',
            autoplay: true,
            ignores: ['progress', 'time'] //去掉播放时长及进度条

          });
          break;

        case 'HlsJsPlayer':
          video.value.player = new HlsJsPlayer({
            id: 'mse',
            url: props.url,
            width: 550,
            height: 351,
            lang: 'en',
            fitVideoSize: 'auto',
            autoplay: true
          });
          break;
      }

      video.value.player.once('complete', () => {
        console.log('complete', video.value.player);
      });
      video.value.player.once('complete', () => {
        try {
          video.value.player.play(); // 尝试再次执行播放

          setTimeout(() => {
            if (!video.value.player.hasStart && video.value.player.currentTime === 0) {
              // hasStart返回false，并且播放时间还是0，那么就可以认为自动播放失效了
              // dash视频播放失败走这里
              ElMessage({
                type: 'error',
                message: t(`播放失败,请刷新重试`)
              });
            }
          }, 5000);
        } catch (e) {
          alert(e);
        }
      });

      if (video.value.player) {
        /* 这里注册监听 */
        // 监听视频开始播放 播放传给父组件的是true 
        video.value.player.on('play', () => {
          console.log('play');
        }); // 监听视频已经暂停 暂停传给父组件的是true 

        video.value.player.on('pause', () => {
          console.log('pause');
        }); // 监听 组件销毁

        video.value.player.on('destroy', () => {
          console.log('destroy');
        }); // 监听 hls格式视频播放的错误

        video.value.player.on('HLS_ERROR', e => {
          ElMessage({
            type: 'error',
            message: t(`播放失败,请刷新重试`)
          });
        });
      }
    }; // 监听播放路径的变化


    watch(() => props.url, (newVal, oldVal) => {
      if (props.url) {
        console.log('监听到url变化开始初始化');
        initPlayer();
      }
    }, {
      immediate: true,
      deep: true
    }); // 暴露销毁组件的方法

    const destroyVideo = () => {
      if (video.value.player) {
        video.value.player.src = '';
        video.value.player.destroy(true);
        video.value.player = null;
      }
    };

    expose({
      destroyVideo
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, null, 512)]);
    };
  }

});